import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable, of, EMPTY} from 'rxjs';
import {PpBreadcrumbsResolver, Breadcrumb} from 'pp-breadcrumbs';
import {catchError, mergeMap} from 'rxjs/operators';
import {ClearingHouseService} from '@app/services/admin/clearing-house.service';

@Injectable()
export class ClearingHouseResolver extends PpBreadcrumbsResolver {
  constructor(private clearingHouseService: ClearingHouseService) {
    super();
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Breadcrumb[]> | Promise<Breadcrumb[]> | Breadcrumb[] {
    const id = Number(route.params['id']);
    if (id === 0) {
      return of([{
        text: 'Add new clearing house',
        path: this.getFullPath(route)
      }]);
    } else {
      return this.clearingHouseService.get(id, true).pipe(catchError(error => {
          return EMPTY;
        }), mergeMap(data => {
          if (data) {
            return of([{
              text: data.name,
              path: this.getFullPath(route)
            }]);
          } else {
            return EMPTY;
          }
        })
      );
    }
  }
}
